import { ArrowLeft } from "lucide-react";
import { Link } from "react-router";

/** Janela de etiquetas sem menu lateral: de qualquer outra tela, o caminho de volta pros pedidos. */
export function VoltarParaPedidos() {
  return (
    <Link
      to="/lab/pedidos"
      className="mb-4 inline-flex h-9 items-center gap-1.5 rounded-md border border-zinc-200 bg-white px-3 text-[12.5px] font-semibold text-zinc-700 transition-colors hover:bg-zinc-50 dark:border-border dark:bg-card dark:text-foreground dark:hover:bg-muted"
    >
      <ArrowLeft className="h-3.5 w-3.5" />
      Voltar para Pedidos
    </Link>
  );
}
